import React from 'react';
import _ from 'underscore';

import {FulfillmentStatus, RequestFulfillmentDefinition} from 'requests/fulfillments/FulfillmentConstants';
import {Request, RequestSchema} from 'requests/RequestConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import * as logging from 'util/Logging';

import SampleGroupTable from './SampleGroupTable';

interface ConfirmReexecuteFulfillmentPaneProps {
  onGoToNextPane: () => void;
  onGoToPrevPane: () => void;
  onRequestClose: () => void;
  requests: Array<Request>;
  fulfillmentDefinitions: Array<RequestFulfillmentDefinition>;
  requestSchemasByRequestId: {[requestId: string]: RequestSchema};
  statusFilter: FulfillmentStatus | null;
  onSetStatusFilter: (status: FulfillmentStatus) => void;
}

const ConfirmReexecuteFulfillmentPane = (props: ConfirmReexecuteFulfillmentPaneProps): JSX.Element => {
  let msg;
  let title;

  if (props.fulfillmentDefinitions.length === 0) {
    logging.warn('Expected at least 1 fulfillmentDefinition');
    props.onGoToNextPane();
  }

  if (props.fulfillmentDefinitions.length === 1) {
    title = 'Re-execute sample?';
    msg =
      "You've selected a sample that has already been executed. Are you sure you want to re-execute this sample?";
  } else {
    title = 'Re-execute samples?';
    msg =
      "You've selected samples that have already been executed. Are you sure you want to re-execute these samples?";
  }

  return (
    <Modal
      buttons={[
        {
          key: 'back',
          text: 'Back',
          className: 'u-mini-spacing-right',
          style: ButtonStyle.TERTIARY_GRAY,
          onClick: props.onGoToPrevPane,
        },
        {
          key: 'next',
          text: 'Re-execute',
          style: ButtonStyle.PRIMARY,
          onClick: props.onGoToNextPane,
        },
      ]}
      scrollable={true}
      large={true}
      expandHeight={true}
      onRequestClose={props.onRequestClose}
      showFooterBorder={false}
      title={title}
      wrapInForm={false}
    >
      <p>{msg}</p>
      {props.fulfillmentDefinitions.length > 0 && (
        <SampleGroupTable
          allowSelect={false}
          // eslint-disable-next-line no-restricted-syntax
          requestIds={_.pluck(props.requests, 'id')}
          fulfillmentDefinitions={props.fulfillmentDefinitions}
          statusFilter={props.statusFilter}
          selectedTaskSchemaId={null}
          selectedFulfillmentDefinitions={[]}
          requestSchemasByRequestId={props.requestSchemasByRequestId}
          onSetStatusFilter={props.onSetStatusFilter}
          onSetSelectedFulfillmentDefinitions={() => {}}
        />
      )}
    </Modal>
  );
};

export default ConfirmReexecuteFulfillmentPane;
